import { render, staticRenderFns } from "./TabPanelCadastro.vue?vue&type=template&id=66822ea6&"
import script from "./TabPanelCadastro.vue?vue&type=script&lang=js&"
export * from "./TabPanelCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports